import { ArrowLeft, X } from "lucide-react";

export function CartDrawerHeader({ step, onBack, onClose }) {
  const title = { cart: "Your Basket", details: "Your Details", payment: "Payment", done: "Confirmed!" }[step];
  return <div className="flex items-center justify-between px-5 py-4 border-b-2 border-biga-ink/10">
    <div className="flex items-center gap-2">
      {step !== "cart" && step !== "done" && <button onClick={onBack} data-testid="checkout-back" className="p-1" aria-label="Back to previous checkout step"><ArrowLeft size={20} /></button>}
      <h2 className="font-display font-black text-2xl" data-testid="cart-drawer-title">{title}</h2>
    </div>
    <button onClick={onClose} data-testid="cart-close" className="w-9 h-9 rounded-full hover:bg-biga-ink/5 flex items-center justify-center" aria-label="Close basket"><X size={20} /></button>
  </div>;
}